import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import FooterLogo from "../../assets/Opensource-02.jpg";
import { fetchSettings } from "../../reduxSlices/settingSlices";
import "./footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);
  const settingsLoading = useSelector((state) => state.settings.loading);

  const handleButtonClick = () => {
    try {
      if (!settings || settingsLoading) {
        navigate("/VerifiyMobileNumber");
        return;
      }

      const mainSetting = settings.find((item) => item.Key === "Main");
      navigate(mainSetting?.Value ? "/VerifiyMobileNumber" : "/eidMubarak");
    } catch (err) {
      console.error("Navigation error:", err);
      navigate("/VerifiyMobileNumber");
    }
  };

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="image-box">
          <img src={FooterLogo} alt="" />
        </div>
        <div className="fastNav">
          <h5>الوصول السريع</h5>
          <ul>
            {/* <li onClick={handleButtonClick}>طلب الصيانة</li> */}
            {/* <Link to="/maintenancePage">
              <li>طلب الصيانة</li>
            </Link> */}
            <Link to="/aboutUs">
              <li>ما يميزنا</li>
            </Link>
            <Link to="/contactUs">
              <li>تواصل معنا</li>
            </Link>
          </ul>
        </div>
        <div className="contactLinks">
          <h5>تواصل معنا</h5>
          <ul>
            <li>
              <a
                href="mailto:hanyamian@gmail.com"
                className="contact-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  fill="none"
                >
                  <path
                    d="M17.5 18.8002H6.5C3.2 18.8002 1 17.2473 1 13.6237V6.37667C1 2.75314 3.2 1.2002 6.5 1.2002H17.5C20.8 1.2002 23 2.75314 23 6.37667V13.6237C23 17.2473 20.8 18.8002 17.5 18.8002Z"
                    stroke="#0D9AE1"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.9264 5.2002L12.9178 9.57427C12.1375 10.1422 11.0487 10.1422 10.2684 9.57427L4.25977 5.2002"
                    stroke="#0D9AE1"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                generalhome.roxel@gmail.com
              </a>
            </li>
            <li>
              <div className="mob-numbers">
                <div className="number-box">
                  <a
                    href="https://wa.me/966555133968"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-item"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        d="M7.49023 6.23535C8.13267 5.5808 9.24012 5.59538 9.92188 6.34668L10.0527 6.50684L11.707 8.77148C12.2427 9.50465 12.1616 10.472 11.5957 11.0488V11.0498L11.2188 11.4326L11.875 12.0762C11.2192 11.4327 11.2177 11.4336 11.2168 11.4346L11.2109 11.4404C11.2083 11.4432 11.2059 11.4463 11.2031 11.4492C11.1976 11.4551 11.1917 11.4619 11.1855 11.4688C11.1729 11.4828 11.1584 11.4994 11.1436 11.5176C11.1139 11.5538 11.0801 11.5982 11.0449 11.6514C10.9743 11.7582 10.898 11.8994 10.833 12.0762C10.7006 12.4362 10.6296 12.9108 10.7188 13.5C10.8936 14.6547 11.6713 16.1891 13.6758 18.2314C15.6782 20.2717 17.1896 21.0715 18.3379 21.252C18.9256 21.3443 19.4008 21.2706 19.7617 21.1328C19.9384 21.0654 20.0785 20.9859 20.1846 20.9131C20.2375 20.8768 20.2825 20.842 20.3184 20.8115C20.336 20.7965 20.3515 20.7823 20.3652 20.7695C20.3722 20.7631 20.3788 20.7568 20.3848 20.751C20.3877 20.7482 20.3909 20.7458 20.3936 20.7432C20.3949 20.7418 20.3962 20.7396 20.3975 20.7383L20.3994 20.7363C20.397 20.7322 20.3509 20.6853 19.6875 20.0342L20.4014 20.7354L20.999 20.126C21.4983 19.6173 22.2917 19.4955 22.9697 19.873L25.4766 21.2695C26.5422 21.8631 26.7263 23.2874 25.9561 24.0723L24.0918 25.9707C23.7308 26.3385 23.3495 26.5401 22.9727 26.5762C21.0822 26.7567 16.1685 26.5999 10.8418 21.1729C5.76213 15.9974 4.91677 11.6397 4.81152 9.74219C4.78511 9.26418 4.99936 8.77244 5.43066 8.33301L7.49023 6.23535Z"
                        stroke="#0D9AE1"
                        strokeWidth="2"
                      />
                    </svg>
                    <span className="footer-region">القصيم:</span>
                    <span className="number">0555133968</span>
                  </a>
                </div>

                <div className="number-box">
                  <a
                    href="https://wa.me/966555133795"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-item"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        d="M7.49023 6.23535C8.13267 5.5808 9.24012 5.59538 9.92188 6.34668L10.0527 6.50684L11.707 8.77148C12.2427 9.50465 12.1616 10.472 11.5957 11.0488V11.0498L11.2188 11.4326L11.875 12.0762C11.2192 11.4327 11.2177 11.4336 11.2168 11.4346L11.2109 11.4404C11.2083 11.4432 11.2059 11.4463 11.2031 11.4492C11.1976 11.4551 11.1917 11.4619 11.1855 11.4688C11.1729 11.4828 11.1584 11.4994 11.1436 11.5176C11.1139 11.5538 11.0801 11.5982 11.0449 11.6514C10.9743 11.7582 10.898 11.8994 10.833 12.0762C10.7006 12.4362 10.6296 12.9108 10.7188 13.5C10.8936 14.6547 11.6713 16.1891 13.6758 18.2314C15.6782 20.2717 17.1896 21.0715 18.3379 21.252C18.9256 21.3443 19.4008 21.2706 19.7617 21.1328C19.9384 21.0654 20.0785 20.9859 20.1846 20.9131C20.2375 20.8768 20.2825 20.842 20.3184 20.8115C20.336 20.7965 20.3515 20.7823 20.3652 20.7695C20.3722 20.7631 20.3788 20.7568 20.3848 20.751C20.3877 20.7482 20.3909 20.7458 20.3936 20.7432C20.3949 20.7418 20.3962 20.7396 20.3975 20.7383L20.3994 20.7363C20.397 20.7322 20.3509 20.6853 19.6875 20.0342L20.4014 20.7354L20.999 20.126C21.4983 19.6173 22.2917 19.4955 22.9697 19.873L25.4766 21.2695C26.5422 21.8631 26.7263 23.2874 25.9561 24.0723L24.0918 25.9707C23.7308 26.3385 23.3495 26.5401 22.9727 26.5762C21.0822 26.7567 16.1685 26.5999 10.8418 21.1729C5.76213 15.9974 4.91677 11.6397 4.81152 9.74219C4.78511 9.26418 4.99936 8.77244 5.43066 8.33301L7.49023 6.23535Z"
                        stroke="#0D9AE1"
                        strokeWidth="2"
                      />
                    </svg>
                    <span className="footer-region">الرياض:</span>
                    <span className="number">0555133795</span>
                  </a>
                </div>
              </div>
            </li>

            <li>
              <div className="socialMedia">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/profile.php?id=100041785110645">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                      >
                        <path
                          d="M32.0375 16.0006C32.0375 24.0816 26.0491 30.7623 18.2697 31.8464C17.5423 31.9473 16.7981 32 16.0427 32C15.1708 32 14.3145 31.9305 13.4806 31.796C5.86375 30.5695 0.046875 23.9638 0.046875 16.0006C0.046875 7.16393 7.2087 0 16.0416 0C24.8745 0 32.0375 7.16393 32.0375 16.0006Z"
                          fill="#1877F2"
                        />
                        <path
                          d="M18.2694 12.8467V16.3322H22.58L21.8974 21.0275H18.2694V31.8451C17.542 31.946 16.7978 31.9987 16.0424 31.9987C15.1705 31.9987 14.3142 31.9292 13.4803 31.7947V21.0275H9.50488V16.3322H13.4803V12.0675C13.4803 9.42169 15.6244 7.27588 18.2705 7.27588V7.27812C18.2784 7.27812 18.2851 7.27588 18.293 7.27588H22.5811V11.3366H19.7791C18.9464 11.3366 18.2705 12.0126 18.2705 12.8456L18.2694 12.8467Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/generaihome_roxel">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                      >
                        <path
                          d="M16.0688 0H15.996C7.18214 0 0.0371094 7.14713 0.0371094 15.9636V16.0364C0.0371094 24.8529 7.18214 32 15.996 32H16.0688C24.8827 32 32.0277 24.8529 32.0277 16.0364V15.9636C32.0277 7.14713 24.8827 0 16.0688 0Z"
                          fill="url(#paint0_linear_30388_5609)"
                        />
                        <path
                          d="M20.9823 6.51025H11.0835C8.34878 6.51025 6.12402 8.73567 6.12402 11.4712V20.5298C6.12402 23.2653 8.34878 25.4907 11.0835 25.4907H20.9823C23.717 25.4907 25.9418 23.2653 25.9418 20.5298V11.4712C25.9418 8.73567 23.717 6.51025 20.9823 6.51025ZM7.87357 11.4712C7.87357 9.70095 9.31378 8.26032 11.0835 8.26032H20.9823C22.752 8.26032 24.1922 9.70095 24.1922 11.4712V20.5298C24.1922 22.3 22.752 23.7407 20.9823 23.7407H11.0835C9.31378 23.7407 7.87357 22.3 7.87357 20.5298V11.4712Z"
                          fill="white"
                        />
                        <path
                          d="M16.0331 20.6143C18.5761 20.6143 20.6462 18.5447 20.6462 15.9998C20.6462 13.4548 18.5773 11.3853 16.0331 11.3853C13.4889 11.3853 11.4199 13.4548 11.4199 15.9998C11.4199 18.5447 13.4889 20.6143 16.0331 20.6143ZM16.0331 13.1364C17.6123 13.1364 18.8967 14.4212 18.8967 16.0009C18.8967 17.5805 17.6123 18.8653 16.0331 18.8653C14.4539 18.8653 13.1695 17.5805 13.1695 16.0009C13.1695 14.4212 14.4539 13.1364 16.0331 13.1364Z"
                          fill="white"
                        />
                        <path
                          d="M21.073 12.1307C21.7578 12.1307 22.316 11.5735 22.316 10.8874C22.316 10.2012 21.7589 9.64404 21.073 9.64404C20.3871 9.64404 19.8301 10.2012 19.8301 10.8874C19.8301 11.5735 20.3871 12.1307 21.073 12.1307Z"
                          fill="white"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_30388_5609"
                            x1="4.71078"
                            y1="27.3249"
                            x2="27.3607"
                            y2="4.68284"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FAAD4F" />
                            <stop offset="0.35" stopColor="#DD2A7B" />
                            <stop offset="0.62" stopColor="#9537B0" />
                            <stop offset="1" stopColor="#515BD4" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/966555133968"
                      className="contact-item"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                      >
                        <path
                          d="M16.06 0H15.9872C7.17335 0 0.0283203 7.14713 0.0283203 15.9636V16.0364C0.0283203 24.8529 7.17335 32 15.9872 32H16.06C24.8739 32 32.0189 24.8529 32.0189 16.0364V15.9636C32.0189 7.14713 24.8739 0 16.06 0Z"
                          fill="#00E510"
                        />
                        <path
                          d="M19.1412 20.68C15.0469 20.68 11.716 17.3469 11.7148 13.2515C11.716 12.2133 12.561 11.3691 13.5966 11.3691C13.7031 11.3691 13.8085 11.3781 13.9093 11.396C14.1313 11.433 14.342 11.5082 14.5359 11.6214C14.5639 11.6382 14.5829 11.6651 14.5874 11.6965L15.02 14.4242C15.0256 14.4567 15.0156 14.4881 14.9943 14.5116C14.7555 14.7762 14.4507 14.9668 14.1111 15.0621L13.9475 15.1081L14.0091 15.2661C14.5672 16.6877 15.7037 17.8234 17.126 18.384L17.284 18.4467L17.33 18.2831C17.4252 17.9434 17.6158 17.6384 17.8803 17.3996C17.8993 17.3817 17.9251 17.3727 17.9509 17.3727C17.9565 17.3727 17.9621 17.3727 17.9688 17.3738L20.6957 17.8066C20.7282 17.8122 20.7551 17.8301 20.7719 17.8582C20.884 18.0521 20.9591 18.264 20.9972 18.486C21.0151 18.5846 21.023 18.6889 21.023 18.7977C21.023 19.8347 20.179 20.6789 19.1412 20.68Z"
                          fill="#FDFDFD"
                        />
                        <path
                          d="M26.4011 15.1014C26.1803 12.6058 25.0371 10.2907 23.1822 8.5832C21.3161 6.86565 18.8952 5.91943 16.3633 5.91943C10.8065 5.91943 6.28525 10.442 6.28525 16.0005C6.28525 17.866 6.79968 19.6834 7.77365 21.2664L5.60156 26.076L12.556 25.3349C13.7654 25.8304 15.0453 26.0816 16.3622 26.0816C16.7085 26.0816 17.0638 26.0636 17.4203 26.0266C17.7341 25.993 18.0513 25.9437 18.3628 25.8809C23.0163 24.9403 26.4134 20.809 26.4403 16.0543V16.0005C26.4403 15.6978 26.4269 15.3951 26.4 15.1014H26.4011ZM12.8239 23.2239L8.97626 23.6342L10.1251 21.0881L9.8953 20.7798C9.87849 20.7574 9.86168 20.735 9.84262 20.7092C8.84513 19.3313 8.31835 17.7035 8.31835 16.0016C8.31835 11.5642 11.9273 7.95426 16.3633 7.95426C20.5192 7.95426 24.0419 11.1976 24.3815 15.3379C24.3994 15.5599 24.4095 15.783 24.4095 16.0027C24.4095 16.0655 24.4083 16.1272 24.4072 16.1933C24.322 19.9053 21.7297 23.0579 18.1028 23.8606C17.826 23.9223 17.5424 23.9694 17.26 23.9997C16.9663 24.0333 16.6648 24.0501 16.3656 24.0501C15.2997 24.0501 14.2641 23.8438 13.2857 23.4357C13.177 23.392 13.0705 23.3449 12.9707 23.2967L12.825 23.2261L12.8239 23.2239Z"
                          fill="#FDFDFD"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright container">
        <p>
          @2025 - جميع الحقوق محفوظة لصالح مجموعة محمد اليحيى للتجارة والصناعة
        </p>
      </div>
    </footer>
  );
};

export default Footer;
